import {AlertTriangle} from 'lucide-react'
import {Link} from 'react-router-dom'
import {Alert, AlertDescription} from '@/components/ui/alert'

interface OpenRequestBannerProps {
    message: string
    linkTo: string
    requestName: string
    testId?: string
    linkTestId?: string
}

/**
 * Banner shown on rule detail pages when an open (DRAFT or PENDING)
 * change request exists — warns the user and links to that request.
 * Callers pass already-translated strings; this component does not call `useI18n()`.
 */
export function OpenRequestBanner({
    message,
    linkTo,
    requestName,
    testId,
    linkTestId,
}: OpenRequestBannerProps) {
    return (
        <Alert className="mb-4" data-testid={testId}>
            <AlertTriangle className="h-4 w-4"/>
            <AlertDescription>
                {message}{' '}
                <Link
                    to={linkTo}
                    className="underline font-medium"
                    data-testid={linkTestId}
                >
                    {requestName}
                </Link>
            </AlertDescription>
        </Alert>
    )
}
